// @vendors
import React from 'react';
import PropTypes from 'prop-types';
// @commons
import { ContentBox } from 'commonsComponents/contentBox'
import OKModal from 'components/commons/OKModal/OKModal'
import { i18n } from 'core/i18n'
// @hooks
import { useFiocStatus } from './hook';

import './FiocUpdateModal.scss'

const { formatText } = i18n


const FiocUpdateModal = ({
    fiocStatus,
    hasCloseButton,
    closeRedirectURL,
    history,
    contractIndex,
    immFlagBasedFeatures,
}) => {
    const { openModal, closeModal, redirectToUpdateFioc, getPOEKeys } = useFiocStatus({
        immFlagBasedFeatures,
        fiocStatus,
        closeRedirectURL,
        history
    });
    const { title, description } = getPOEKeys(contractIndex);

    const buildModalContent = () => {
        return (
            <ContentBox
                title={formatText(title)}
                customClassName="contract-fioc-modal"
                hasShadow={false}
            >
                <div className="contract-fioc-modal__wrapper">
                    <p className="contract-fioc-modal__text">{formatText(description)}</p>
                </div>
            </ContentBox>
        );
    }

    const buildModal = () => {
        return (
            <OKModal
                content={buildModalContent()}
                contentOverflow="auto"
                footerType="navigation"
                isOpen={openModal}
                shouldCloseOnOverlayClick={false}
                onCloseCallback={closeModal}
                customCloseButton={!hasCloseButton && closeModal}
                overlayClassName="contract-fioc-modal"
                onPrimaryButtonClick={redirectToUpdateFioc}
                onSecondaryButtonClick={closeModal}
                primaryButtonText="contractsView-fiocRequired_callToActionButton"
                secondaryButtonText='common-cancel'
                size='large'
            />
        )
    }

    return (
        <div>
            {buildModal()}
        </div>
    )
}

FiocUpdateModal.propTypes = {
    fiocStatus: PropTypes.object.isRequired,
    hasCloseButton: PropTypes.bool.isRequired,
    closeRedirectURL: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    contractIndex: PropTypes.string.isRequired
};

FiocUpdateModal.defaultProps = {
    hasCloseButton: true
};

module.exports = FiocUpdateModal;
